<template>
  <div ref="sticker" class="sticker" :style="style">
    <button
      v-if="dev"
      @click="copy"
      style="position: absolute; top: 50%; left: 50%; translate: -50% -50%;"
    >
      {{ name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    dev: {
      type: Boolean,
      default: false,
    },
    left: {
      type: String,
      default: '0',
    },
    top: {
      type: String,
      default: '0',
    },
    size: {
      type: String,
      default: '100',
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    tag() {
      let style = this.$refs.sticker.style
      return `<StickMe name="${this.name}" size="${style.width.replace(
        '%',
        ''
      )}" left="${style.left.replace('%', '')}" top="${style.top.replace(
        '%',
        ''
      )}" />`
    },
    style() {
      return {
        left: this.left == 'unset' ? 'unset' : `${this.left}%`,
        top: this.top == 'unset' ? 'unset' : `${this.top}%`,
        width: `${this.size}%`,
        backgroundImage: `url('/static/about-me/s${this.name}.webp')`,
      }
    },
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.tag)
      } catch (err) {}
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/about-me/StickMe.vue